import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Input } from "@mui/material";
import Search from "../../../../assets/icons/search-icon.svg";
import PropTypes from "prop-types";

function SearchBar({
  value = "",
  onChange,
  placeholder = "Type here...",
  onKeyDown,
  style = {},
}) {
  const [portalContainer, setPortalContainer] = useState(null);

  useEffect(() => {
    // Wait for the portal container to be available
    const checkContainer = () => {
      const container = document.getElementById("navbar-search-portal");
      if (container) {
        setPortalContainer(container);
      } else {
        // Retry after a short delay if container is not available
        setTimeout(checkContainer, 100);
      }
    };

    checkContainer();
  }, []);

  // If the portal container doesn't exist, don't render anything
  if (!portalContainer) {
    return null;
  }

  const searchElement = (
    <Input
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      startAdornment={
        <img src={Search} alt="search" style={{ marginRight: "10px" }} />
      }
      disableUnderline
      sx={{
        width: "100%",
        backgroundColor: "white",
        borderRadius: "10px",
        ...style,
      }}
    />
  );

  return createPortal(searchElement, portalContainer);
}

SearchBar.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  onKeyDown: PropTypes.func,
  style: PropTypes.object,
};

export default SearchBar;
